package ai.beakman.undercover.game

/** Avatar emoji determinístico por nome. Porte de `src/lib/avatars.ts`. */
object Avatars {
    private val AVATARS = listOf(
        "🦊", "🐼", "🐨", "🐯", "🦁", "🐸", "🐙", "🦉", "🦇", "🐺",
        "🦄", "🐲", "🦕", "🦖", "🐳", "🦈", "🐊", "🐍", "🦎", "🐢",
        "🦑", "🦐", "🦀", "🐡", "🐠", "🐟", "🦋", "🐞", "🦗", "🐝",
    )

    fun forPlayer(name: String): String {
        var hash = 0
        for (ch in name) {
            hash = ch.code + (hash shl 5) - hash // mesma fórmula do app web (32-bit wrap)
        }
        val index = ((hash % AVATARS.size) + AVATARS.size) % AVATARS.size
        return AVATARS[index]
    }
}
